import React, {
  useEffect, useState,
} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import {
  Alert,
  Button,
  Checkbox, Drawer, Image, notification, Popconfirm, Select, Table,
} from 'antd';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import tickIcon from '@Images/icons/tick.png';
import FormAddEntity from './FormAddEntity';
import PRZSelect from '../../../../Common/UI/PRZSelect';
import './style.scss';

const { Option } = Select;

const FormCustomFieldV3 = (props) => {
  const {
    selectedCFV2, createCFV2, updateCFV2, user, callback, isLineField, createCFV2Loading, updateCFV2Loading,
    availableEntities, tags, cfData, entity, cfGlobal,
  } = props;

  const [showLinkEntityDrawer, setShowLinkEntityDrawer] = useState(false);
  const [fieldName, setFieldName] = useState('');
  const [fieldType, setFieldType] = useState('');
  const [fieldPlaceHolder, setFieldPlaceHolder] = useState('');
  const [dropDownOptions, setDropDownOptions] = useState([]);
  const [isPrintable, setIsPrintable] = useState(true);
  const [isRequired, setIsRequired] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [curentCf, setCurentCf] = useState(null);
  const [enabledEntities, setEnabledEntities] = useState([]);
  const [selectedEntityCf, setSelectedEntityCf] = useState(null);

  useEffect(() => {
    if (selectedCFV2 && selectedCFV2?.cf_id !== curentCf?.cf_id) {
      setFieldName(selectedCFV2?.field_name);
      setFieldType(selectedCFV2?.field_type);
      setFieldPlaceHolder(selectedCFV2?.placeholder);
      setIsRequired(selectedCFV2?.is_required);
      setIsActive(selectedCFV2?.is_active);
      setDropDownOptions(selectedCFV2?.default_data);
      setIsPrintable(selectedCFV2?.is_printable);
      setCurentCf(selectedCFV2);
      setEnabledEntities(selectedCFV2?.applicable_entities);
    } else {
      setFieldName('');
      setFieldType('');
      setFieldPlaceHolder('');
      setIsRequired(false);
      setIsActive(false);
      setDropDownOptions([]);
      setIsPrintable(false);
      setCurentCf(null);
      setEnabledEntities([]);
    }
  }, [selectedCFV2]);

  /**
   *
   */
  const handleAddCF = () => {
    setFormSubmitted(true);
    if (fieldName && fieldType && (fieldType === 'DROPDOWN' ? dropDownOptions?.length : true)) {
      const payload = {
        org_id: user?.tenant_info?.org_id,
        field_name: fieldName,
        field_type: fieldType?.toUpperCase(),
        is_required: isRequired,
        placeholder: fieldPlaceHolder,
        default_data: dropDownOptions?.length ? dropDownOptions : [],
        is_document_level_field: !isLineField,
        applicable_entities: enabledEntities,
      };
      if (selectedCFV2) {
        payload.cf_id = selectedCFV2?.cf_id;
        payload.cf_id = selectedCFV2?.cf_id;
        updateCFV2(payload, callback);
      } else if (['DROPDOWN', 'ATTACHMENT', 'CHECKBOX', 'DATE']?.includes(payload?.field_type) && payload?.applicable_entities?.find((item) => item?.default_expression?.trim())) {
        notification.open({
          type: 'error',
          message: 'You are not allowed to add formula for attachment, dropdown, checkbox or date type inputs',
          duration: 4,
          placement: 'top',
        });
      } else if (enabledEntities?.length < 1) {
        notification.open({
          type: 'error',
          message: 'Please add this field to at least one document. Please click on "+Add to another document" to select the documents.',
          duration: 4,
          placement: 'top',
        });
      } else createCFV2(payload, callback);
    }
  };

  const columns = [
    {
      title: 'Entity',
      render: (record) => {
        let entityName = '';
        if (record?.entity_name === 'MANUFACTURING_ORDER_LINE') {
          entityName = 'MANUFACTURING_ORDER_RAW_MATERIAL';
        } else if (record?.entity_name === 'BILL_OF_MATERIAL') {
          entityName = 'BOM_FINISHED_GOOD';
        } else if (record?.entity_name === 'BILL_OF_MATERIAL_LINE') {
          entityName = 'BOM_RAW_MATERIAL';
        } else {
          entityName = record?.entity_name;
        }
        return (
          <div>
            {entityName?.replaceAll('_', ' ')?.toProperCase()}
          </div>
        )
      },
    },
    {
      title: 'Active',
      render: (record) => (
        <Image src={tickIcon} preview={false} className={`cf-entity-status ${record?.is_active ? 'cf-entity-status__active' : ''}`} />
      ),
    },
    {
      title: 'Mandatory',
      render: (record) => (
        <Image src={tickIcon} preview={false} className={`cf-entity-status ${record?.is_required ? 'cf-entity-status__active' : ''}`} />
      ),
    },
    {
      title: 'Printable',
      render: (record) => (
        <Image src={tickIcon} preview={false} className={`cf-entity-status ${record?.is_printable ? 'cf-entity-status__active' : ''}`} />
      ),
    },
    {
      title: 'Update',
      render: (record) => (
        <Image src={tickIcon} preview={false} className={`cf-entity-status ${record?.is_editable_on_update ? 'cf-entity-status__active' : ''}`} />
      ),
    },
    {
      title: 'Carry Forward',
      render: (record) => (
        !['PRODUCTS', 'VENDORS', 'STOCK_ADJUSTMENT', "CUSTOMERS"].includes(record?.entity_name) &&
        <Image src={tickIcon} preview={false} className={`cf-entity-status ${record?.is_editable_while_carrying_forward ? 'cf-entity-status__active' : ''}`} />
      ),
    },
    {
      title: 'Formula',
      width: '150px',
      render: (record) => {
        const replacePlaceholders = (formula, customFields) => {
          if (formula) {
            return formula?.replace(/{{cf_(\d+)}}/g, (match, id) => {
              const field = customFields?.find((fl) => fl.cf_id == id);
              return field ? `<span>${field.field_name}</span>` : match;
            });
          }
          return '-';
        };
        return <div dangerouslySetInnerHTML={{ __html: `<div>${replacePlaceholders(record?.default_expression, cfGlobal?.data?.document_line_custom_fields)}<div>` }} className="cf-formula__preview" />;
      },
    },
    {
      title: '',
      render: (record) => {
        const isRestricted = selectedCFV2?.is_system_field && ((record?.entity_name?.toUpperCase() === 'PRODUCTS') || ['Rate', 'Quantity']?.includes(fieldName));
        return (
          <div style={{
            textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center',
          }}
          >
            <div
              className="roundIconButton"
              onClick={() => {
                setShowLinkEntityDrawer(true);
                setSelectedEntityCf(record);
              }}
            >
              <EditOutlined />
            </div>
            <Popconfirm
              title="Are you sure you want to remove this field from this document?"
              onConfirm={() => {
                if (!isRestricted) {
                  setEnabledEntities(enabledEntities?.filter((item) => record?.entity_name !== item?.entity_name));
                }
              }}
              disabled={isRestricted}
              placement='topRight'
            >
              <div className="roundIconButton" style={{ color: isRestricted ? '#fcb6b6' : '#f51010' }}>
                <DeleteOutlined />
              </div>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const baseOptions = [
    { label: 'Text', value: 'TEXT' },
    { label: 'Number', value: 'NUMBERS' },
    { label: 'Dropdown', value: 'DROPDOWN' },
    { label: 'Attachment', value: 'ATTACHMENT' },
    { label: 'Date', value: 'DATE' },
  ];
  
  if (!isLineField) {
    baseOptions.splice(4, 0, { label: 'Textarea', value: 'TEXTAREA' });
    baseOptions.splice(5, 0, { label: 'Checkbox', value: 'CHECKBOX' });
  } 

  return (
    <div className="cf-v3__wrapper">
      {selectedCFV2?.is_system_field && (
        <Alert
          type="info"
          showIcon
          message="This is a system field. You cannot add custom formula or update this field."
        />
      )}
      <Drawer
        open={showLinkEntityDrawer}
        width="460px"
        mask
        onClose={() => {
          setShowLinkEntityDrawer(false);
          setSelectedEntityCf(null);
        }}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '415px' }}>
            <H3Text text="Add this field to a new form" className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setShowLinkEntityDrawer(false);
                setSelectedEntityCf(null);
              }}
            />
          </div>
        </div>
        <FormAddEntity
          availableEntities={availableEntities}
          enabledEntities={enabledEntities}
          tags={tags}
          selectedCFV2={selectedCFV2}
          fieldType={fieldType}
          onSubmit={(newEntity) => {
            if (showLinkEntityDrawer && enabledEntities?.find((item) => item?.entity_name === newEntity?.entity_name)) {
              setEnabledEntities([
                ...(enabledEntities?.filter((item) => item?.entity_name !== newEntity?.entity_name) || []),
                newEntity,
              ]?.map((item) => ({ ...item, field_type: item?.fieldtype })));
            } else {
              setEnabledEntities([
                ...(enabledEntities || []),
                newEntity,
              ]?.map((item) => ({ ...item, field_type: item?.fieldtype })));
            }
            setShowLinkEntityDrawer(false);
          }}
          selectedEntityCf={selectedEntityCf}
          isDocField={!isLineField}
          cfData={cfData}
        />
      </Drawer>

      <div className="ant-row">
        <div className="ant-col-md-12">
          <H3FormInput
            name="field name"
            type="text"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            onChange={(event) => setFieldName(event.target.value)}
            disabled={createCFV2Loading || updateCFV2Loading || selectedCFV2?.is_system_field}
            value={fieldName}
            label="Field Name"
            maxlength="100"
            required
            showError={formSubmitted && !fieldName}
          />
        </div>
        <div className="ant-col-md-12">
          <H3FormInput
            name="field placeholder"
            type="text"
            containerClassName="orgInputContainer"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            placeholder=""
            onChange={(event) => setFieldPlaceHolder(event.target.value)}
            disabled={createCFV2Loading || updateCFV2Loading || selectedCFV2?.is_system_field}
            value={fieldPlaceHolder}
            label="Field Placeholder"
            maxlength="100"
          />
        </div>
        <div className="ant-col-md-12">
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              Field Type
              <span style={{ color: 'red', marginLeft: '5px' }}>*</span>
            </label>
            <PRZSelect
              value={fieldType}
              filterOption={false}
              onChange={(value) => setFieldType(value)}
              disabled={createCFV2Loading || updateCFV2Loading || selectedCFV2}
              options={baseOptions}
              showError={formSubmitted && !fieldType}
              errorName="a field type"
              errorClassName="formError"
            />
          </div>
        </div>
        {fieldType === 'DROPDOWN' && (
          <div className="ant-col-md-12">
            <div className="orgInputContainer">
              <label className="orgFormLabel">
                Add Options
                <span style={{ color: 'red', marginLeft: '5px' }}>*</span>
              </label>
              <PRZSelect
                mode="tags"
                value={dropDownOptions}
                filterOption={false}
                onChange={(value) => setDropDownOptions(value)}
                disabled={createCFV2Loading || updateCFV2Loading || selectedCFV2}
                maxTagCount="responsive"
                showError={formSubmitted && !dropDownOptions?.length}
                errorName={"a field type"}
                errorClassName={"formError"}
              />
              {formSubmitted && !dropDownOptions?.length && <div className="formError">*Please select a field Type</div>}
            </div>
          </div>
        )}
        <div className="ant-col-md-24">
          <Table
            columns={columns}
            size="small"
            scroll="scroll"
            loading={createCFV2Loading || updateCFV2Loading}
            dataSource={enabledEntities || []}
            pagination={false}
          />
          {!['Rate', 'Quantity', '']?.includes(fieldName.trim()) && fieldType && (
            <div
              className="new-row-button"
              onClick={() => setShowLinkEntityDrawer(true)}
            >
              + Add to another document
            </div>
          )}
        </div>
        <div className="custom-drawer__footer">
          <div className="ant-col-md-6">
            <Button
              type="primary"
              onClick={() => handleAddCF()}
              loading={createCFV2Loading || updateCFV2Loading}
              disabled={createCFV2Loading || updateCFV2Loading}
            >
              {!selectedCFV2 ? 'Add Custom Field' : 'Update Custom Field'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ UserReducers, CFV2Reducers }) => ({
  user: UserReducers.user,
  createCFV2Loading: CFV2Reducers.createCFV2Loading,
  updateCFV2Loading: CFV2Reducers.updateCFV2Loading,
  cfGlobal: CFV2Reducers.cfGlobal,
});

const mapDispatchToProps = (dispatch) => ({
  createCFV2: (payload, callback) => dispatch(CFV2Actions.createCFV2(payload, callback)),
  updateCFV2: (payload, callback) => dispatch(CFV2Actions.updateCFV2(payload, callback)),
});

FormCustomFieldV3.propTypes = {
  user: PropTypes.any,
  createCFV2Loading: PropTypes.any,
  updateCFV2Loading: PropTypes.any,
  createCFV2: PropTypes.func,
  updateCFV2: PropTypes.func,
  callback: PropTypes.func,
  selectedCFV2: PropTypes.any,
  entity: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FormCustomFieldV3));
